import { Box, Typography, alpha } from "@mui/material";

import nutricionFondo from "../../assets/nutricionFondo.png";
import dermatologia from "../../assets/dermatologia.png";
import motivacionalParejas from "../../assets/motivacionalParejas.png";
import entrenamiento from "../../assets/entrenamiento.png";
import endocrinologia from "../../assets/endocrinologia.png";
import psicologia from "../../assets/psicologia.png";
import ginecologia from "../../assets/ginecologia.png";
import medicinaFuncional from "../../assets/medicinaFuncional.png";
import cardiologia from "../../assets/cardiologia.png";
import pisiquiatria from "../../assets/pisiquiatria.png";

// Map: string key → imported image
export const BACKGROUND_MAP = {
  nutricionFondo,
  dermatologia,
  motivacionalParejas,
  entrenamiento,
  endocrinologia,
  psicologia,
  ginecologia,
  medicinaFuncional,
  cardiologia,
  pisiquiatria,
};

const BACKGROUND_LABELS = {
  nutricionFondo: "Nutrición",
  dermatologia: "Dermatología",
  motivacionalParejas: "Motivacional",
  entrenamiento: "Entrenamiento",
  endocrinologia: "Endocrinología",
  psicologia: "Psicología",
  ginecologia: "Ginecología",
  medicinaFuncional: "Medicina Funcional",
  cardiologia: "Cardiología",
  pisiquiatria: "Psiquiatría",
};

const BackgroundPicker = ({ selected, onSelect, color }) => {
  const bgKeys = Object.keys(BACKGROUND_MAP);

  return (
    <Box>
      <Typography
        variant="caption"
        sx={{ fontWeight: 700, mb: 1, display: "block", color: "text.secondary" }}
      >
        Fondo
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(5, 1fr)",
          gap: 1,
          maxHeight: 220,
          overflowY: "auto",
          p: 0.5,
        }}
      >
        {bgKeys.map((key) => {
          const isSelected = selected === key;
          return (
            <Box
              key={key}
              onClick={() => onSelect(key)}
              sx={{
                cursor: "pointer",
                borderRadius: 2,
                overflow: "hidden",
                border: isSelected
                  ? `3px solid ${color || "#D0749B"}`
                  : "3px solid transparent",
                transition: "all 0.15s",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: 2,
                },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: 60,
                  backgroundImage: `url(${BACKGROUND_MAP[key]})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              />
              <Typography
                variant="caption"
                sx={{
                  display: "block",
                  textAlign: "center",
                  py: 0.25,
                  fontSize: "0.6rem",
                  fontWeight: isSelected ? 700 : 400,
                  color: isSelected ? color || "#D0749B" : "text.secondary",
                  bgcolor: isSelected ? alpha(color || "#D0749B", 0.08) : "transparent",
                }}
              >
                {BACKGROUND_LABELS[key] || key}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default BackgroundPicker;
